import { useState } from "react";
import { tagCloud } from "@/mocks/gossip";

export default function TagCloudSection() {
  const [active, setActive] = useState<string | null>(null);
  const activeTag = tagCloud.find((tag) => tag.label === active);

  return (
    <section id="tags" className="w-full scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
              <i className="ri-price-tag-3-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              热门标签
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜群众常逛的话题标签</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              下面是社区里出现频率较高的话题标签。点选任意标签可以查看它的讨论量，帮助你判断哪个方向最近最热闹。
            </p>
          </div>
          {activeTag && (
            <div className="self-start rounded-lg border border-primary-200 bg-primary-50 px-4 py-2 text-sm text-primary-800">
              已选：<strong className="font-medium">{activeTag.label}</strong> · 共 {activeTag.count} 条相关讨论
            </div>
          )}
        </div>

        <div className="mt-7 flex flex-wrap gap-2.5 md:gap-3">
          {tagCloud.map((tag) => {
            const isActive = active === tag.label;
            return (
              <button
                key={tag.label}
                type="button"
                onClick={() => setActive(isActive ? null : tag.label)}
                aria-pressed={isActive}
                className={
                  "inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors cursor-pointer whitespace-nowrap " +
                  (isActive
                    ? "border-primary-500 bg-primary-500 text-background-50 dark:text-foreground-950"
                    : "border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-700")
                }
              >
                <i className="ri-hashtag w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
                {tag.label}
                <span className={"rounded-full px-2 py-0.5 text-xs " + (isActive ? "bg-background-50/25 text-background-50 dark:text-foreground-950" : "bg-background-200 text-foreground-500")}>
                  {tag.count}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}